<template>
  <footer id="footer">
    <div class="footer-container">
      <!-- 底部版权信息 -->
      <div class="footer-bottom">
        <div class="copyright-content">
          <div class="copyright-text">
            <p>&copy; 2026 VDS · 南京唯迪爱思文化传媒有限公司 保留所有权利</p>
            <p class="icp-info"><a href="tel:4008375338">400 837 5338</a> · <a href="mailto:support@vds.pub">support@vds.pub</a></p>
            <p class="icp-info"><a href="https://fursuit.tv/terms/index.html">用户服务协议（兽频道）</a> · <a href="https://fursuit.tv/privacy/index.html">个人信息保护政策（兽频道）</a></p>
            <p class="icp-info">
              <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2025173595号-1</a>
            </p>
          </div>
          <div class="design-credit">
            <span>Design with VDS Lumiora</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "vc-footer"
};
</script>

<style scoped>
footer {
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%);
  color: white;
  font-family: 'MiSans-Regular', Arial, sans-serif;
  position: relative;
}

footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.2) 50%, transparent 100%);
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 60px;
  padding: 60px 0 40px;
}

/* 品牌区域 */
.footer-brand {
  max-width: 400px;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.brand-logo h2 {
  font-family: 'MiSans-Bold', Arial, sans-serif;
  font-size: 32px;
  font-weight: 900;
  margin: 0;
  background: linear-gradient(135deg, #fff, rgba(255, 255, 255, 0.8));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-tagline {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.brand-description {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

/* 快速链接 */
.footer-links {
  display: flex;
  gap: 40px;
}

.link-group h4 {
  font-family: 'MiSans-Bold', Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 20px 0;
  color: white;
}

.link-group a {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 14px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  position: relative;
}

.link-group a:hover {
  color: white;
  transform: translateX(4px);
}

.link-group a::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #fff, rgba(255, 255, 255, 0.5));
  transition: width 0.3s ease;
}

.link-group a:hover::before {
  width: 8px;
}

/* 社交媒体区域 */
.footer-social h4 {
  font-family: 'MiSans-Bold', Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 20px 0;
  color: white;
}

.social-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.social-link:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  color: white;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.social-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-icon svg {
  width: 18px;
  height: 18px;
  transition: all 0.3s ease;
}

/* 特定社交媒体颜色 */
.social-link.bilibili:hover {
  border-color: #fb7299;
}

.social-link.bilibili:hover .social-icon {
  color: #fb7299;
}

.social-link.youtube:hover {
  border-color: #ff0000;
}

.social-link.youtube:hover .social-icon {
  color: #ff0000;
}

.social-link.developer:hover {
  border-color: #6366f1;
}

.social-link.developer:hover .social-icon {
  color: #6366f1;
}

/* 底部版权区域 */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 30px 0;
}

.copyright-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.copyright-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.copyright-text p {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.icp-info a {
  color: rgba(255, 255, 255, 0.4);
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-info a:hover {
  color: rgba(255, 255, 255, 0.6);
}

.design-credit {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  .footer-social {
    grid-column: 1 / -1;
  }

  .social-links {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
  }

  .social-link {
    flex: 0 0 auto;
    min-width: 140px;
  }
}

@media (max-width: 768px) {
  .footer-container {
    padding: 0 15px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 40px 0 30px;
  }

  .brand-logo {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .brand-logo h2 {
    font-size: 28px;
  }

  .footer-links {
    flex-direction: column;
    gap: 30px;
  }

  .social-links {
    flex-direction: column;
  }

  .social-link {
    min-width: auto;
  }

  .copyright-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .footer-bottom {
    padding: 20px 0;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 0 12px;
  }

  .footer-content {
    padding: 30px 0 20px;
    gap: 30px;
  }

  .brand-logo h2 {
    font-size: 24px;
  }

  .brand-tagline {
    font-size: 12px;
    padding: 3px 8px;
  }

  .brand-description {
    font-size: 13px;
  }

  .link-group h4,
  .footer-social h4 {
    font-size: 14px;
    margin-bottom: 15px;
  }

  .social-link {
    padding: 10px 12px;
    font-size: 13px;
  }

  .social-icon svg {
    width: 16px;
    height: 16px;
  }

  .footer-bottom {
    padding: 16px 0;
  }

  .copyright-text p,
  .design-credit {
    font-size: 11px;
  }
}
</style>
